import type { FC } from "react";
import type { ToastPosition } from "@UI/types/notifications.ts";
import DPortal from "@UI/components/Atoms/Portal/DPortal.tsx";
import DToastNotifications from "@UI/components/Molecules/Notification/DToastNotifications.tsx";
import {
  dismissToast,
  useToasts,
} from "@UI/components/Molecules/Notification/toastStore.ts";

const POSITIONS: ToastPosition[] = ["top-center", "bottom-center"];
const MAX_VISIBLE = 5;

/**
 * Renders the live toast stacks. Mount once at the app root.
 * Groups toasts by position and caps each stack at MAX_VISIBLE (oldest drop off).
 */
const DToastContainer: FC = () => {
  const toasts = useToasts();

  return (
    <DPortal target="root">
      {POSITIONS.map(position => {
        const group = toasts
          .filter(toast => toast.position === position)
          .slice(-MAX_VISIBLE);

        if (group.length === 0) return null;

        return (
          <DToastNotifications
            key={position}
            position={position}
            notifications={group}
            onDismiss={dismissToast}
          />
        );
      })}
    </DPortal>
  );
};

export default DToastContainer;
